(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !window.DesignMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setUtilityBarHeight();
      this.setMegaMenuHeight();

      // Initial CSS variable setup with delay to ensure all elements are rendered
      setTimeout(() => {
        this.setAnnouncementHeight();
        this.setUtilityBarHeight();
      }, 100);

      setTimeout(() => {
        this.setHeaderHeight();
      }, 100);

      setTimeout(() => {
        this.setHeaderHeight();
        this.setStickyMegaMenuHeight();
      }, 500);

      setTimeout(() => {
        this.setHeaderHeight();
        this.setStickyMegaMenuHeight();
      }, 1500);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setUtilityBarHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setMegaMenuHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', () => {
        this.setAnnouncementHeight();
        this.setUtilityBarHeight();
      });

      this.createObserver();

      // Create mega menu observer with a small delay to ensure all elements are ready
      setTimeout(() => {
        this.createMegaMenuObserver();
      }, 100);
    }

    setHeaderHeight() {
      const $utilityBar = document.getElementById('utilityBar') || null;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if ($utilityBar && this?.header) {
        const fullHeaderHeight = (this.header.offsetHeight + $utilityBar.offsetHeight);
        document.documentElement.style.setProperty('--full-header-height', `${fullHeaderHeight}px`);
      }

      // Set sticky-header-height to just the header element (not including mega menu)
      const headerElement = document.querySelector('header.header');
      if (headerElement) {
        document.documentElement.style.setProperty('--sticky-header-height', `${headerElement.offsetHeight}px`);
      } else {
        document.documentElement.style.setProperty('--sticky-header-height', `${this.header.offsetHeight}px`);
      }
    }

    setAnnouncementHeight() {
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
      }
    }

    setUtilityBarHeight() {
      const utilityBar = document.getElementById('utilityBar');
      if (utilityBar) {
        document.documentElement.style.setProperty('--utility-bar-height', `${utilityBar.offsetHeight}px`);
      } else {
        document.documentElement.style.setProperty('--utility-bar-height', '0px');
      }
    }

    setMegaMenuHeight() {
      const megaMenu = document.querySelector('.header-mega-menu');
      if (megaMenu) {
        document.documentElement.style.setProperty('--mega-menu-height', `${megaMenu.offsetHeight}px`);
        this.setStickyMegaMenuHeight();
      } else {
        document.documentElement.style.setProperty('--mega-menu-height', '0px');
        document.documentElement.style.setProperty('--sticky-mega-menu-height', '0px');
      }
    }

    setStickyMegaMenuHeight() {
      const megaMenu = document.querySelector('.header-mega-menu');
      if (megaMenu) {
        const isHidden = megaMenu.classList.contains('header-mega-menu-hide');
        if (isHidden) {
          document.documentElement.style.setProperty('--sticky-mega-menu-height', '0px');
        } else {
          const megaMenuHeight = megaMenu.offsetHeight;
          document.documentElement.style.setProperty('--sticky-mega-menu-height', `${megaMenuHeight}px`);
        }
      } else {
        document.documentElement.style.setProperty('--sticky-mega-menu-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.megaMenuObserver) {
        this.megaMenuObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    createMegaMenuObserver() {
      const megaMenu = document.querySelector('.header-mega-menu');
      if (megaMenu) {
        this.megaMenuObserver = new MutationObserver(() => {
          this.setStickyMegaMenuHeight();
        });

        this.megaMenuObserver.observe(megaMenu, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-debug"] && !window.DesignMode) return;
  try {
    
  class PromoDebugPanel extends HTMLElement {
    constructor() {
      super();
      this.tracker = null;
      this.abortController = new AbortController();
      this.init();
    }

    connectedCallback() {
      this.updateDisplay();
      this.attachEventListeners();

      // Listen for storage changes
      window.addEventListener('storage', () => this.updateDisplay());
      window.addEventListener('userStateUpdated', () => this.updateDisplay());
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    init() {
      // Wait for UserStateTracker to be available
      const checkTracker = () => {
        const hasTracker = window.SDG
          && window.SDG.EverlanePromoMsgs
          && window.SDG.EverlanePromoMsgs.UserStateTracker;

        if (hasTracker) {
          this.tracker = new window.SDG.EverlanePromoMsgs.UserStateTracker();
          this.updateDisplay();
        } else {
          setTimeout(checkTracker, 100);
        }
      };
      checkTracker();
    }

    attachEventListeners() {
      this.querySelector('#debug-mark-ordered').addEventListener('click', () => {
        if (this.tracker) {
          this.tracker.markOrderPlaced();
          window.location.reload();
        }
      }, {
        signal: this.abortController.signal,
      });

      this.querySelector('#debug-mark-subscribed').addEventListener('click', () => {
        if (this.tracker) {
          this.tracker.markFooterSubscribed();
          window.location.reload();
        }
      }, {
        signal: this.abortController.signal,
      });

      this.querySelector('#debug-mark-both').addEventListener('click', () => {
        if (this.tracker) {
          this.tracker.markOrderPlaced();
          this.tracker.markFooterSubscribed();
          window.location.reload();
        }
      }, {
        signal: this.abortController.signal,
      });

      this.querySelector('#debug-reset').addEventListener('click', () => {
        if (window.SDG && window.SDG.EverlanePromoMsgs) {
          window.SDG.EverlanePromoMsgs.reset();
          window.location.reload();
        }
      }, {
        signal: this.abortController.signal,
      });
    }

    updateDisplay() {
      if (!this.tracker) return;

      const state = this.tracker.state;
      const shouldHide = this.tracker.shouldHidePromoMessage(true);

      this.querySelector('#debug-order-status').textContent = state.hasPlacedOrder ? 'Yes' : 'No';
      this.querySelector('#debug-subscription-status').textContent = state.hasSubscribedViaFooter ? 'Yes' : 'No';
      this.querySelector('#debug-last-updated').textContent = state.lastUpdated
        ? new Date(state.lastUpdated).toLocaleString()
        : 'Never';
      this.querySelector('#debug-should-hide').textContent = shouldHide ? 'Yes' : 'No';
    }
  }

  const isPublished = Shopify?.theme?.role === 'main';
  const debugPanelIsDefined = customElements.get('promo-debug-panel');

  if (!isPublished && !debugPanelIsDefined) {
    customElements.define('promo-debug-panel', PromoDebugPanel);
  }

  } catch(e) { console.error(e); }
})();
})();
